<span *ngIf="readonly" class="readonly-view">
  <div class="readonly-label">{{ label | translate }}</div>
  <div
    *ngIf="options && control.value !== undefined; else empty"
    [value]="getOptionsLabel(control.value)"
    chipView
    class="readonly-content"></div>
  <ng-template #empty class="readonly-content">---</ng-template>
</span>
<span *ngIf="!readonly" class="p-float-label">
  <p-treeSelect
    [filter]="filter"
    (onNodeSelect)="onNodeSelect($event)"
    [ngClass]="{ 'ng-invalid ng-dirty': errors, readonly: readonly }"
    [formControl]="control"
    [metaKeySelection]="metaKeySelection"
    [options]="options"
    [selectionMode]="selectionMode"
    [showClear]="!readonly && showClear"
    appendTo="body"
  ></p-treeSelect>
  <label class="block">
    <span *ngIf="showLabel"> {{ label | translate }}</span>
    <span *ngIf="checkRequire()" class="p-errors" style="color: red; margin-left: 3px">*</span></label
  >

  <div class="relative b-errors">
    <ng-container *ngIf="errors">
      <small class="p-error error-msg block fadeinup animation-duration-300">
        <span class="block">{{ getError().key | translate: getError().required }}</span>
      </small>
    </ng-container>
  </div>
</span>
